import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/glyph/add';
import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../messages';

const AddEntryButton = ({ onClick }: { onClick: () => void }) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip content={formatMessage(messages['add-entry-button.label'])}>
      {(tooltipProps) => (
        <IconButton
          {...tooltipProps}
          onClick={onClick}
          icon={AddIcon}
          label={formatMessage(messages['add-entry-button.label'])}
        />
      )}
    </Tooltip>
  );
};

export default AddEntryButton;
